import { render, staticRenderFns } from "./tag-add.vue?vue&type=template&id=0b769a99&scoped=true&"
import script from "./tag-add.vue?vue&type=script&lang=js&"
export * from "./tag-add.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/i-switch.less?vue&type=style&index=0&id=0b769a99&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b769a99",
  null
  
)

component.options.__file = "tag-add.vue"
export default component.exports